<template>
  <div>
    <form @submit.prevent="updateProduct">
      <div class="mb-3">
        <va-input v-model="product.name" class="mb-0" />
        <div
          v-if="!$v.product.name.required && $v.product.name.$error"
          class="error-message"
        >
          Обязательно для заполнения
        </div>
      </div>
      <div class="mb-3">
        <va-input v-model="product.price" class="mb-0" type="number" />
        <div
          v-if="!$v.product.price.required && $v.product.price.$error"
          class="error-message"
        >
          Обязательно для заполнения
        </div>
      </div>
      <div class="mb-3">
        <va-input v-model="product.qty" type="number" />
        <div
          v-if="!$v.product.qty.required && $v.product.qty.$error"
          class="error-message"
        >
          Обязательно для заполнения
        </div>
      </div>
      <div class="text-center">
        <va-button @click.prevent="$emit('hide')">Отменить</va-button>
        <va-button type="submit">Сохранить</va-button>
      </div>
    </form>
  </div>
</template>

<script>
import api from "@/api/axios";
import { required } from "vuelidate/lib/validators";
export default {
  props: {
    productInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      product: { ...this.productInfo },
    };
  },
  validations: {
    product: {
      name: {
        required,
      },
      price: {
        required,
      },
      qty: {
        required,
      },
    },
  },
  methods: {
    async updateProduct() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      } else {
        const { name, price, qty } = this.product;
        if (qty > 0 && price > 0) {
          try {
            const data = {
              name,
              price: Number(price),
              qty: Number(qty),
            };
            await api.put(
              "admin/additional-products/" + this.productInfo.id,
              data
            );
            for (const key in this.form) {
              this.form[key] = "";
            }
            this.$emit("hide");
            this.$emit("neeFetch");
          } catch (error) {
            return error;
          }
        }
      }
    },
  },
};
</script>

<style>
</style>